import type {
  DestructiveActionDefs,
  DestructiveActionArgs,
  DestructiveAction,
} from '../types'

const DestructiveActionFactory = {
  delete: {
    type: 'action',
    label: 'Delete Content',
    actionType: 'delete',
    destructive: true,
  },
} as const satisfies DestructiveActionDefs

export const getDestructiveActions = ({
  deletable,
  isPresenting,
  queueView,
  userCanEditContent,
}: DestructiveActionArgs): DestructiveAction[] => {
  if (isPresenting || !userCanEditContent || !deletable || queueView) return []

  return [DestructiveActionFactory.delete]
}
